const initialState = {
  isLogout: false,
  isLogoutTiming: false,
};

export default initialState;
